import React from "react";
import CircleIcon from "../../atoms/circleIcon/circleIcon";
import Skeleton from "react-loading-skeleton";
import {IconSource} from "../../../shared/enums/iconSource";
import "./modalDetailContent.sass";
import classNames from "classnames";

export interface IModalDetailContentProps {
  /**
   * The icon to show before the body.
   */
  icon: IconSource;
  /**
   * Is this component loading.
   */
  isLoading?: boolean;
  /**
   * A simple string to show in the body.
   * @remarks This is an alternative to using children. If both are supplied only children will show.
   */
  content?: string;
  /**
   * Should the icon and text be center aligned.
   * @remarks Leave false if the body is expected to grow to more than one line. In this case a small offset is applied to the body.
   */
  isCentred?: boolean;
  /**
   * The content to show in the body.
   * @remarks Children takes precedence over anything set in content.
   */
  children?: JSX.Element | JSX.Element[];
  dataTestId?: string;
}

const ModalDetailContent: React.FC<IModalDetailContentProps> = ({
  icon,
  isLoading,
  content,
  isCentred = true,
  children,
  dataTestId
}) => {
  return (
    <div
      className={classNames("modal-detail-content", {
        centred: isCentred || isLoading
      })}
      data-testid={dataTestId}
    >
      <CircleIcon icon={icon} />
      {isLoading ? (
        <div className="loader">
          <Skeleton />
        </div>
      ) : (
        <div>{children ?? content}</div>
      )}
    </div>
  );
};

export default ModalDetailContent;
